const BASE_CATEGORY_NAV_ITEMS = [
  {
    slug: "dogs",
    label: "Собакам",
    menuLabel: "Товари для собак",
    query: "Для собак",
    path: "/category/dogs",
    legacyPath: "/dogs",
    legacyPaths: ["/products/category/dogs"],
    image:
      "https://dl.dropboxusercontent.com/scl/fi/a9n2i1dah8kkg0dqjemgs/dog.png?rlkey=v01elayr8fg516f7wzlgbda8k&st=k4kooch2&dl=0",
    description:
      "Корм, ласощі, амуніція, засоби догляду та аксесуари для собак.",
    seoTitle:
      "Товари для собак - купити корм, ласощі та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для собак у MyZooShop: сухий і вологий корм, ласощі, іграшки, амуніцію, засоби догляду, лежанки та аксесуари. Доставка по Україні.",
    seoText:
      "У розділі товарів для собак зібрані корми, ласощі, іграшки, амуніція, засоби догляду, лежанки та аксесуари для щоденної турботи про вашого улюбленця.",
    subcategories: [
      "Корм для собак",
      "Ласощі",
      "Іграшки",
      "Амуніція",
      "Догляд",
      "Лежанки та аксесуари",
    ],
    popularBrands: ["Brit", "Purina", "Royal Canin", "Club 4 BonusKopecks"],
  },
  {
    slug: "cats",
    label: "Котам",
    menuLabel: "Товари для котів",
    query: "Для котів",
    path: "/category/cats",
    legacyPath: "/cats",
    legacyPaths: ["/products/category/cats"],
    image:
      "https://dl.dropboxusercontent.com/scl/fi/i53jr3mwtd5az5ckfxkz0/cat.png?rlkey=seyrg4v0axwbbmep550p1lpsj&st=xbp175ge&dl=0",
    description:
      "Корм, наповнювачі, іграшки, кігтеточки та догляд для котів.",
    seoTitle:
      "Товари для котів - купити корм, наповнювачі та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для котів у MyZooShop: корм, ласощі, наповнювачі, іграшки, засоби догляду та аксесуари. Зручна доставка по Україні.",
    seoText:
      "У розділі товарів для котів ви знайдете корми, ласощі, наповнювачі, іграшки, засоби догляду та аксесуари для щоденної турботи про вашого улюбленця.",
    subcategories: [
      "Корм для котів",
      "Ласощі для котів",
      "Наповнювачі",
      "Іграшки",
      "Догляд і гігієна",
      "Переноски та аксесуари",
    ],
    popularBrands: ["Royal Canin", "Purina", "Whiskas", "Cat's Best"],
  },
  {
    slug: "birds",
    label: "Птахам",
    menuLabel: "Товари для птахів",
    query: "Для птахів",
    path: "/category/birds",
    legacyPath: "/birds",
    legacyPaths: ["/products/category/birds"],
    image:
      "https://dl.dropboxusercontent.com/scl/fi/d7b0bo0l4o2dgxepxnuuw/Dove.png?rlkey=n9kqsc40mro519p0q5g6hmqg9&st=oyn4q30s&dl=0",
    description:
      "Корм, клітки, поїлки, іграшки та аксесуари для декоративних птахів.",
    seoTitle:
      "Товари для птахів - купити корм, клітки та аксесуари | MyZooShop",
    metaDescription:
      "Товари для птахів у MyZooShop: корм, ласощі, клітки, поїлки, іграшки, вітаміни та аксесуари для декоративних птахів. Доставка по Україні.",
    seoText:
      "У розділі товарів для птахів зібрані корми, клітки, поїлки, іграшки, вітаміни та аксесуари для комфортного догляду за декоративними птахами.",
    subcategories: [
      "Корм для птахів",
      "Ласощі",
      "Клітки",
      "Поїлки та годівниці",
      "Іграшки",
      "Вітаміни",
    ],
    popularBrands: ["Vitakraft", "Tetra", "AnimAll", "Природа"],
  },
  {
    slug: "rodents",
    label: "Гризунам",
    menuLabel: "Товари для гризунів",
    query: "Для гризунів",
    path: "/category/rodents",
    legacyPath: "/rodents",
    legacyPaths: ["/products/category/rodents"],
    image:
      "https://dl.dropboxusercontent.com/scl/fi/blz2508zg4hxqvivlcwx9/Otter.png?rlkey=p331cwopgn717bml3org830u5&st=y8buh0f6&dl=0",
    description:
      "Корм, підстилки, будиночки та аксесуари для гризунів.",
    seoTitle:
      "Товари для гризунів - купити корм, підстилки та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для гризунів у MyZooShop: корм, сіно, підстилки, клітки, будиночки, іграшки, поїлки та аксесуари. Доставка по Україні.",
    seoText:
      "У розділі товарів для гризунів є корм, сіно, підстилки, клітки, будиночки, іграшки, поїлки та аксесуари для хом'яків, морських свинок, кроликів та інших улюбленців.",
    subcategories: [
      "Корм для гризунів",
      "Сіно та підстилки",
      "Клітки",
      "Будиночки",
      "Поїлки та годівниці",
      "Іграшки",
    ],
    popularBrands: ["Vitakraft", "Padovan", "Versele-Laga", "Природа"],
  },
  {
    slug: "fish",
    label: "Рибам",
    menuLabel: "Товари для риб",
    query: "Для риб",
    path: "/category/fish",
    legacyPath: "/fish",
    legacyPaths: ["/products/category/fish"],
    image:
      "https://dl.dropboxusercontent.com/scl/fi/ukbwj32as0kce9sta2gvn/Fish.png?rlkey=qwckaj4ig99b30npuuvi9u5p0&st=yimsu4hu&dl=0",
    description:
      "Корм, догляд за водою, акваріумні аксесуари та обладнання для риб.",
    seoTitle:
      "Товари для риб - купити корм, акваріуми та догляд за водою | MyZooShop",
    metaDescription:
      "Товари для риб у MyZooShop: корм, акваріумні аксесуари, обладнання, засоби догляду за водою, фільтри та декор. Доставка по Україні.",
    seoText:
      "У розділі товарів для риб ви знайдете корм, акваріумні аксесуари, обладнання, засоби догляду за водою, фільтри та декор для стабільного акваріума.",
    subcategories: [
      "Корм для риб",
      "Акваріуми",
      "Фільтри",
      "Догляд за водою",
      "Декор",
      "Освітлення",
    ],
    popularBrands: ["Tetra", "Aquael", "JBL", "Sera"],
  },
  {
    slug: "reptiles",
    label: "Рептиліям",
    menuLabel: "Товари для рептилій",
    query: "Для рептилій",
    path: "/category/reptiles",
    legacyPath: "/reptiles",
    legacyPaths: ["/products/category/reptiles"],
    image:
      "https://dl.dropboxusercontent.com/scl/fi/g7e9s4ktb2j5g1p75y4jn/Frog.png?rlkey=mb44xpfcpyf6do8bc0pwhgh77&st=yvjfg1n7&dl=0",
    description:
      "Корм, тераріуми, освітлення та базові аксесуари для рептилій.",
    seoTitle:
      "Товари для рептилій - купити корм, тераріуми та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для рептилій у MyZooShop: корм, тераріуми, освітлення, обігрів, субстрати та аксесуари. Доставка по Україні.",
    seoText:
      "У розділі товарів для рептилій зібрані корми, тераріуми, освітлення, обігрів, субстрати та аксесуари для базового догляду за екзотичними улюбленцями.",
    subcategories: [
      "Корм для рептилій",
      "Тераріуми",
      "Освітлення",
      "Обігрів",
      "Субстрати",
      "Аксесуари",
    ],
    popularBrands: ["Tetra", "Exo Terra", "JBL", "Trixie"],
  },
];

const CATEGORY_SEO_OVERRIDES = {
  cats: {
    seoTitle:
      "Товари для котів — корм, наповнювачі та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для котів у MyZooShop: сухий і вологий корм, ласощі, наповнювачі, іграшки, засоби догляду та аксесуари з доставкою по Україні.",
    seoText:
      "У категорії товарів для котів ви знайдете сухий і вологий корм, ласощі, наповнювачі, іграшки, кігтеточки, переноски, засоби догляду та аксесуари для щоденної турботи про вашого улюбленця.",
    subcategories: [
      "Корм для котів",
      "Ласощі для котів",
      "Наповнювачі",
      "Іграшки",
      "Догляд і гігієна",
      "Переноски та аксесуари",
    ],
  },
  dogs: {
    seoTitle:
      "Товари для собак — корм, ласощі, іграшки та аксесуари | MyZooShop",
    metaDescription:
      "Товари для собак у MyZooShop: корм, ласощі, амуніція, іграшки, засоби догляду, лежанки та аксесуари для щоденної турботи.",
    seoText:
      "У категорії товарів для собак зібрані сухі та вологі корми, ласощі, іграшки, амуніція, лежанки, засоби догляду та аксесуари для прогулянок, харчування і комфорту собаки щодня.",
    subcategories: [
      "Корм для собак",
      "Ласощі",
      "Іграшки",
      "Амуніція",
      "Догляд",
      "Лежанки та аксесуари",
    ],
  },
  birds: {
    seoTitle:
      "Товари для птахів — корм, клітки та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для птахів у MyZooShop: корми, ласощі, клітки, поїлки, годівниці, іграшки, вітаміни та аксесуари для декоративних птахів.",
    seoText:
      "У категорії товарів для птахів є корми, ласощі, клітки, поїлки, годівниці, іграшки, вітаміни та аксесуари для хвилястих папуг, канарок, корел та інших декоративних птахів.",
    subcategories: [
      "Корм для птахів",
      "Ласощі",
      "Клітки",
      "Поїлки та годівниці",
      "Іграшки",
      "Вітаміни",
    ],
  },
  rodents: {
    seoTitle:
      "Товари для гризунів — корм, клітки, наповнювачі та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для гризунів у MyZooShop: корми, сіно, наповнювачі, клітки, поїлки, іграшки та аксесуари для хом’яків, морських свинок, кроликів та інших улюбленців.",
    seoText:
      "У категорії товарів для гризунів ви знайдете корми, сіно, наповнювачі, клітки, поїлки, будиночки, іграшки та аксесуари для хом’яків, морських свинок, кроликів, шиншил та інших маленьких улюбленців. MyZooShop допомагає підібрати якісні товари для щоденного догляду, харчування та комфорту гризунів.",
    subcategories: [
      "Корм для гризунів",
      "Сіно та наповнювачі",
      "Клітки",
      "Будиночки",
      "Поїлки та годівниці",
      "Іграшки",
    ],
  },
  fish: {
    seoTitle:
      "Товари для риб — корм, акваріуми та догляд за водою | MyZooShop",
    metaDescription:
      "Товари для риб у MyZooShop: корм, акваріуми, фільтри, декор, обладнання та засоби догляду за водою для стабільного акваріума.",
    seoText:
      "У категорії товарів для риб ви знайдете корми, акваріуми, фільтри, освітлення, декор, обладнання та засоби догляду за водою, які допомагають підтримувати чистий і стабільний акваріум.",
    subcategories: [
      "Корм для риб",
      "Акваріуми",
      "Фільтри",
      "Догляд за водою",
      "Декор",
      "Освітлення",
    ],
  },
  reptiles: {
    seoTitle:
      "Товари для рептилій — корм, тераріуми та аксесуари | MyZooShop",
    metaDescription:
      "Купуйте товари для рептилій у MyZooShop: корм, тераріуми, освітлення, обігрів, субстрати та аксесуари для догляду за екзотичними улюбленцями.",
    seoText:
      "У категорії товарів для рептилій зібрані корми, тераріуми, лампи, обігрівачі, субстрати, укриття та аксесуари для базового догляду за черепахами, ящірками, зміями та іншими екзотичними улюбленцями.",
    subcategories: [
      "Корм для рептилій",
      "Тераріуми",
      "Освітлення",
      "Обігрів",
      "Субстрати",
      "Аксесуари",
    ],
  },
};

export const CATEGORY_NAV_ITEMS = BASE_CATEGORY_NAV_ITEMS.map((item) => ({
  ...item,
  ...(CATEGORY_SEO_OVERRIDES[item.slug] || {}),
}));

export const PROMOTIONS_PATH = "/promotions";
export const CUSTOMER_SERVICE_INFO_PATH = "/customer-service-info";
export const DELIVERY_PAYMENT_PATH = CUSTOMER_SERVICE_INFO_PATH;
export const CUSTOMER_SERVICE_DELIVERY_PAYMENT_PATH = `${CUSTOMER_SERVICE_INFO_PATH}#delivery-payment`;
export const CUSTOMER_SERVICE_RETURNS_EXCHANGE_PATH = `${CUSTOMER_SERVICE_INFO_PATH}#returns-exchange`;
export const BONUS_PROGRAM_PATH = "/bonus-program";

export const PRIMARY_NAV_ITEMS = [
  { label: "Каталог", path: "/products" },
  { label: "Товари для котів", path: "/category/cats" },
  { label: "Товари для собак", path: "/category/dogs" },
  { label: "Акції", path: PROMOTIONS_PATH },
  { label: "Оплата і доставка", path: DELIVERY_PAYMENT_PATH },
];

export const FOOTER_NAV_SECTIONS = [
  {
    title: "Категорії",
    ariaLabel: "Категорії товарів",
    links: [
      ...CATEGORY_NAV_ITEMS.map(({ menuLabel, path }) => ({
        label: menuLabel,
        path,
      })),
      { label: "Акційні товари", path: PROMOTIONS_PATH },
    ],
  },
  {
    title: "Клієнтам",
    ariaLabel: "Інформація для клієнтів",
    links: [
      { label: "Доставка та оплата", path: CUSTOMER_SERVICE_DELIVERY_PAYMENT_PATH },
      { label: "Бонусна програма", path: BONUS_PROGRAM_PATH },
      { label: "Повернення та обмін", path: CUSTOMER_SERVICE_RETURNS_EXCHANGE_PATH },
      { label: "Авторизація", path: "/login" },
      { label: "Реєстрація", path: "/register" },
    ],
  },
];

export const TECHNICAL_PATH_PREFIXES = [
  "/admin",
  "/cart",
  "/checkout",
  "/profile",
  "/user",
  "/orders",
  "/wishlist",
  "/order-summary",
  "/order-confirmation",
  "/order-success",
  "/payment-requisites",
  "/payment/processing",
  "/payment/success",
  "/payment/failed",
  "/payment-success",
  "/payment-failed",
  "/pay/additional",
  "/login",
  "/register",
  "/reset-password",
  "/cabinet",
  "/product/code",
];

export const getCategoryBySlug = (slug) =>
  CATEGORY_NAV_ITEMS.find((item) => item.slug === slug) || null;

export const getCategoryByQuery = (query) =>
  CATEGORY_NAV_ITEMS.find((item) => item.query === query) || null;

export const getCategoryByPath = (pathname) =>
  CATEGORY_NAV_ITEMS.find(
    (item) =>
      item.path === pathname ||
      item.legacyPath === pathname ||
      item.legacyPaths?.includes(pathname),
  ) || null;
